module.exports = __webpack_public_path__ + "img/pro-zdslider1.25fe7bc9.png";